define([
	"dojo/_base/lang",
	"csi/def",
	"csi/def/Action",
	"csi/def/ActionFactory",
	"csi/def/Request",
	"csi/def/ViewRef",
	"csi/util",
	"csi/sessionConstants"
], function(lang, def, Action, ActionFactory, Request, ViewRef, util, sessionConstants) {
	function _doesTypeHaveLabelTemplate(type) {
		return sessionConstants.labelTemplateTypes.includes(type);
	}

	return ActionFactory.declare("GeneratePackListLabelFile", Action, {
		// String: the class name
		type: null,

		constructor: function(obj) {
			this.type = util.getProperty(obj, "Type");
			this.m_class = this.m_class || "iconPrintLabel";
			this.m_typeControl = this.m_typeControl || def.ACTION_ICON;

			this.m_viewRef = this.m_viewRef || lang.mixin(new ViewRef(), {m_id: "GeneratePackListLabelFileForm", m_url: "centric://APPAREL/Views"});
			this.m_accessAction = this.m_accessAction || ((ctx, action) => _doesTypeHaveLabelTemplate(this.type));
			this.m_request = this.m_request || lang.mixin(((ctx, action) => new Request().removeParameter("URL").addParameter("URL", ctx.getNode().$URL)), {m_module: "Sourcing", m_operation: "GeneratePackListLabelFile"});
		}
	});
});